<template>
  <div class="input-group input-group-outline mb-3 select" :class="classObject">
    <label class="form-label">{{ label }}</label>
    <select
      :value="value"
      :class="'form-control ' + c_css"
      :maxlength="maxlength"
      :minlength="minlength"
      :autocomplete="autocomplete"
      @input="setValue"
      @focus="handleFocus"
      @blur="handleBlur"
      :disabled="isBlocked === true"
      readonly="readonly"
    >
      <option v-if="notDefault" value></option>
      <option
        v-for="(option, index) in processedOptions"
        :key="index"
        :value="option.value"
      >{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, required: false, default: false },
    options: { type: Array, required: true },
    value: { type: [String, Number], required: false, default: "" },
    label: { type: String, required: false, default: "" },
    placeholder: { type: String, required: false, default: "" },
    c_css: { type: String, required: false, default: "" },
    maxlength: { type: String, required: false, default: "" },
    minlength: { type: String, required: false, default: "" },
    autocomplete: { type: String, required: false, default: "" },
    notDefault: { type: Boolean, required: false, default: false },
    id: { type: String, required: false, default: "" },
    userAdmin: { type: [Number, String], required: false }
  },
  mounted() {
    if (!this.disabled) {
      let input = this.$el.lastElementChild;
      setTimeout(() => {
        input.removeAttribute("readonly");
      }, 500);
    }
  },
  data() {
    return {
      focused: false
    };
  },
  computed: {
    isBlocked() {
      if (this.userAdmin != null && this.userAdmin != 1) {
        return true;
      }
      return false;
    },
    processedOptions() {
      return this.options.map(option => {
        const keys = Object.keys(option);
        return {
          value: option[keys[0]], // Primeiro valor
          text: option[keys[1]] // Segundo valor
        };
      });
    },
    classObject() {
      return {
        "focused is-focused": this.focused,
        "is-filled": this.value,
        'my-input-disabled':this.isBlocked === true
      };
    }
  },
  methods: {
    handleFocus() {
      this.focused = true;
    },
    handleBlur() {
      this.focused = false;
    },
    setValue(event) {
      this.$emit("input", event.target.value, this.id);
    }
  }
};
</script>
<style scoped>
select.form-control {
  /* WebKit */
  -webkit-appearance: listbox;
  /* Mozilla */
  -moz-appearance: listbox;
  /* Opera */
  -o-appearance: listbox;
  /* Internet Explorer */
  -ms-appearance: listbox;
  /* CSS3 */
  appearance: listbox;
}
</style>